import { $api } from "../generated/client";

export const useGetNumberOfReturnRequestPerMonthQuery = ({
	shopId,
	startMonthTimeStamp,
}: {
	shopId: string;
	startMonthTimeStamp: string;
}) => {
	const query = $api.useQuery(
		"get",
		"/shops/{shopId}/analytics/number-of-return-requests-per-month",
		{
			params: {
				path: { shopId },
				query: {
					startMonthTimeStamp,
				},
			},
		},
	);
	return query;
};
